import { render } from "./BasisEinstellungen.vue?vue&type=template&id=6462ebb2&scoped=true&ts=true"
import script from "./BasisEinstellungen.vue?vue&type=script&lang=ts"
export * from "./BasisEinstellungen.vue?vue&type=script&lang=ts"

import "./BasisEinstellungen.vue?vue&type=style&index=0&id=6462ebb2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6462ebb2"]])

export default __exports__